module.exports = __webpack_public_path__ + "media/images/help/video-8e15ac103c0a390611996e62fb0a38bf.png";